'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updateAdresa_007DBCv1 = updateAdresa_007DBCv1;
exports.updateMapAdresa_007DBCv1 = updateMapAdresa_007DBCv1;
exports.updateListAdresa_007DBCv1 = updateListAdresa_007DBCv1;
exports.updateFindAdresyParams_7230C2v1 = updateFindAdresyParams_7230C2v1;
exports.updateMapFindAdresyParams_7230C2v1 = updateMapFindAdresyParams_7230C2v1;
exports.updateListFindAdresyParams_7230C2v1 = updateListFindAdresyParams_7230C2v1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:05Z                      #

// ##############################################################

function updateAdresa_007DBCv1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'AdresaVO'
    });

    return result;
}

function updateMapAdresa_007DBCv1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateAdresa_007DBCv1(data[key]);
    });
    return result;
}

function updateListAdresa_007DBCv1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_007DBCv1);
}

function updateFindAdresyParams_7230C2v1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'FindAdresyParamsVO'
    });

    return result;
}

function updateMapFindAdresyParams_7230C2v1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateFindAdresyParams_7230C2v1(data[key]);
    });
    return result;
}

function updateListFindAdresyParams_7230C2v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFindAdresyParams_7230C2v1);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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